import { LoginRepository } from "./login.repository";
import { NamedEntityDto } from "approot/global/models/common.model";

declare var localStorage: Storage;

export interface UserRoleDto {
	userId: number;
	schoolId: number;
	role: NamedEntityDto;
}

export interface AccountInfo {
	activeToken?: string;
	secureActiveToken?: string;
	refreshToken?: string;
	refreshTokenHash?: string;
	accessToken?: string;
	logintime: Date;
	user: NamedEntityDto;
	userRoles?: UserRoleDto[];
	currentOrganization: NamedEntityDto;
	organizations: NamedEntityDto[];
	active: boolean;
	storeTokens?: boolean;
}

export interface StoredRefreshToken {
	userId: number;
	orgId: number;
	refreshToken: string;
}

export class SessionStore {
	/*@ngInject*/
	constructor(private loginRepository?: LoginRepository) {
	}

	private getFromStorage(): AccountInfo[] {
		let storedInfo = localStorage.getItem("session-store");
		if (!storedInfo) {
			return [];
		}
		//todo. handle errors
		return JSON.parse(storedInfo);
	}

	private setToStorage(list: AccountInfo[]) {
		localStorage.setItem("session-store", JSON.stringify(list));
	}

	getRefreshTokensList(): StoredRefreshToken[] {
		let storedInfo = localStorage.getItem("refresh-tokens-store");
		let list: StoredRefreshToken[] = null;
		if (storedInfo)  {
			list = JSON.parse(storedInfo);
		}
		return list ?? [];
	}

	setRefreshTokensList(list: StoredRefreshToken[]) {
		localStorage.setItem("refresh-tokens-store", JSON.stringify(list));
	}

	getRefreshToken(userId: number, orgId: number): StoredRefreshToken {
		return this.getRefreshTokensList().find(x => x.userId == userId && x.orgId == orgId);
	}

	setRefreshToken(token: StoredRefreshToken) {
		let list: StoredRefreshToken[] = this.getRefreshTokensList();
		let index: number = list.findIndex(x => x.userId == token.userId && x.orgId == token.orgId);

		if (index >= 0) {
			Object.assign(list[index], token);
		} else {
			list.push(token);
		}

		this.setRefreshTokensList(list);
	}

	removeRefreshTokens(account: AccountInfo) {
		let list = this.getRefreshTokensList();
		let filtered = list.filter(x => x.userId !== account.user.id);
		this.setRefreshTokensList(filtered);
	}

	removeRefreshToken(userId: number, orgId: number) {
		let list = this.getRefreshTokensList();
		let filtered = list.filter(x => x.userId !== userId || x.orgId != orgId);
		this.setRefreshTokensList(filtered);
	}

	put(account: AccountInfo) {
		let list = this.getFromStorage();
		list.push(account);
		let filtered = this.getUniques(list);

		this.setToStorage(filtered);
	}

	remove(account: AccountInfo) {
		let list = this.getFromStorage();
		let filtered = list.filter((a) => a.user.id !== account.user.id);

		this.setToStorage(filtered);
		this.removeRefreshTokens(account);
	}

	private getUniques(accounts: AccountInfo[]) {
		let grouped = arrayHelper.groupBy(accounts, (s) => s.user.id);

		let filtered = grouped.map((gr) => {
			let values = gr.values;

			let sorted = values.sort((a, b) => {
				let aval = new Date(a.logintime).getTime() + (a.active ? 10000 : 0)
				let bval = new Date(b.logintime).getTime() + (b.active ? 10000 : 0)
				return aval - bval
			});

			let lastLogin = sorted.pop();
			return lastLogin;
		});

		return filtered;
	}

	getStored(): AccountInfo[] {
		let list = this.getFromStorage();
		return this.getUniques(list);
	}

	getActive(): Promise<AccountInfo[]> {
		let list = this.getFromStorage();
		let filtered = this.getUniques(list);

		// todo. не отображать слишком старые (более месяца)
		return this.loginRepository.checkAccountList(filtered)
			.then((activeAccounts) => {
				let saveCopy = activeAccounts.map((a) => Object.assign({}, a));
				saveCopy.forEach(x => x.activeToken = null);
				
				this.setToStorage(saveCopy);
				return activeAccounts;
			});
	}
}

interface group {
	key: string;
	values: any[];
}

const arrayHelper = {
	groupBy(array, keyOptions): group[] {
		var helper = {};

		var result = array.reduce(function (r, o) {

			let key;
			if (typeof (keyOptions) === "function") {
				key = keyOptions(o);
			}
			else if (Array.isArray(keyOptions)) {
				key = keyOptions.reduce((memo, prop) => memo += o[prop] + "|", "");
			}

			let group: group = helper[key];
			if (!group) {
				group = {
					key: key,
					values: []
				}

				helper[key] = group;

				r.push(group);
			}

			group.values.push(o);
			return r;
		}, []);

		return result;
	}
}
